import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

// types
import { Generic } from "types/filters-store.types";

// utils
import { getStateName } from "utils/advanced-search";

const fetchMSACodes = async () => {
  const response = await fetch("/msa-codes.json"); // Path to your JSON file in the public directory
  if (!response.ok) {
    throw new Error("Failed to fetch JSON data");
  }
  return response.json();
};

export type MSACode = {
  name: string;
  code: string;
};

export type MSAFilterTerm = Pick<Generic, "label" | "value"> & {
  originalLabel: string;
  originalValue: string;
  stateName: string;
};

export type GroupedMSAFilterTerm = {
  state: string;
  msas: MSAFilterTerm[];
};

export default function useMSACodes() {
  const { isLoading, error, data } = useQuery<MSACode[]>({
    queryKey: ["msa-codes"],
    queryFn: fetchMSACodes,

    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const refineMSACodes: MSAFilterTerm[] = useMemo(() => {
    return !data
      ? []
      : data
          .map((item: MSACode) => {
            const stateName = getStateName(item.name.split(", ")[1] as string);

            if (!stateName) return null;

            return {
              label: item.name,
              value: item.code.toString(),
              originalLabel: item.name,
              originalValue: item.code.toString(),
              stateName: stateName,
            };
          })
          .filter(Boolean);
  }, [data]);

  return {
    isLoading,
    error,
    msaCodes: refineMSACodes,
  };
}
